/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCategoryLookupDto
 */
export interface UpdateCategoryLookupDto {
    /**
     * Unique category code
     * @type {string}
     * @memberof UpdateCategoryLookupDto
     */
    code?: string;
    /**
     * Category name in English
     * @type {string}
     * @memberof UpdateCategoryLookupDto
     */
    nameEn?: string;
    /**
     * Category name in Arabic
     * @type {string}
     * @memberof UpdateCategoryLookupDto
     */
    nameAr?: string;
    /**
     * Category description
     * @type {string}
     * @memberof UpdateCategoryLookupDto
     */
    description?: string;
    /**
     * Category image URL
     * @type {string}
     * @memberof UpdateCategoryLookupDto
     */
    imageUrl?: string;
    /**
     * Whether the category is active
     * @type {boolean}
     * @memberof UpdateCategoryLookupDto
     */
    isActive?: boolean;
    /**
     * Sort order for display (1-1000)
     * @type {number}
     * @memberof UpdateCategoryLookupDto
     */
    sortOrder?: number;
}

/**
 * Check if a given object implements the UpdateCategoryLookupDto interface.
 */
export function instanceOfUpdateCategoryLookupDto(value: object): value is UpdateCategoryLookupDto {
    return true;
}

export function UpdateCategoryLookupDtoFromJSON(json: any): UpdateCategoryLookupDto {
    return UpdateCategoryLookupDtoFromJSONTyped(json, false);
}

export function UpdateCategoryLookupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCategoryLookupDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'nameEn': json['nameEn'] == null ? undefined : json['nameEn'],
        'nameAr': json['nameAr'] == null ? undefined : json['nameAr'],
        'description': json['description'] == null ? undefined : json['description'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
    };
}

export function UpdateCategoryLookupDtoToJSON(value?: UpdateCategoryLookupDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'code': value['code'],
        'nameEn': value['nameEn'],
        'nameAr': value['nameAr'],
        'description': value['description'],
        'imageUrl': value['imageUrl'],
        'isActive': value['isActive'],
        'sortOrder': value['sortOrder'],
    };
}

